import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M23.77,16.23l-3.21-5.54A1.5,1.5,0,0,0,19.3,10H16.52a.48.48,0,0,0-.43.25l-1.85,3.16-.37.64a3.16,3.16,0,0,1-1.48,1.24,2.86,2.86,0,0,1-1.09.21H8.93a.5.5,0,0,0-.43.25l-.27.46a1.51,1.51,0,0,0,0,1.6l3.21,5.5a1.49,1.49,0,0,0,1.26.69H19.3a1.5,1.5,0,0,0,1.27-.71l3.19-5.46A1.51,1.51,0,0,0,23.77,16.23ZM16,14a3,3,0,1,1-3,3A3,3,0,0,1,16,14Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M15.78,6.23,12.57.69A1.5,1.5,0,0,0,11.31,0H4.7A1.49,1.49,0,0,0,3.43.71L.24,6.21a1.51,1.51,0,0,0,0,1.6l3.21,5.5A1.49,1.49,0,0,0,4.7,14h6.61a1.5,1.5,0,0,0,1.27-.71l3.19-5.46A1.51,1.51,0,0,0,15.78,6.23ZM8,10a3,3,0,1,1,3-3A3,3,0,0,1,8,10Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }